import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";
import { ageMaximum, ageMinimum } from "mappers";

export const qaBoardingQueueService = {
	getQaBoardingList,
	getAssignableUsersQaBoarding,
	claimToUserQaBoarding,
	unclaimToUserQaBoarding,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getQaBoardingList({ tab, page, filters, sortBy }) {
	const options = {
		url: `${API_URL}/api/applications/boarding/qa/${tab}`,
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.id || undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
			// filters
			number: filters?.number,
			auto_boarding_status: filters?.auto_boarding_status
				? filters?.auto_boarding_status.value
				: undefined,
			agent_name: filters?.agentName,
			agent_office: filters?.agentOffice,
			merchant_name: filters?.merchant_name,
			processor_id: filters?.processor?.id,
			sponsor_id: filters?.sponsor?.id,
			boarding_ach_status: filters?.boardingAchStatus?.value,
			boarding_qa_assignee_id: filters?.assignedTo?.id,
			boarding_qa_completed_by_id: filters?.completeBy?.id,
			mid: filters?.mid,
			qa_result: filters?.qa_result?.name,
			boarding_qa_completed_from: convertDateToISO(filters?.completeFrom),
			boarding_qa_completed_to: convertDateToISO(filters?.completeTo, {
				addTime: TIME_OFFSET_DAY_END,
			}),
			age_in_boarding_qa_from: ageMinimum(filters),
			age_in_boarding_qa_to: ageMaximum(filters),
		},
	};

	return axiosWithAuth(options);
}

function claimToUserQaBoarding({ id, userId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/boarding/qa/${id}/assign`,
		data: { user_id: userId },
	};

	return axiosWithAuth(options);
}

function unclaimToUserQaBoarding(id) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/boarding/qa/${id}/unassign`,
	};

	return axiosWithAuth(options);
}

function getAssignableUsersQaBoarding(
	search,
	page_index,
	show_inactive = false,
) {
	const params = {
		search,
		page_index,
		page_size: 20,
		show_inactive,
	};

	const options = {
		method: "GET",
		params,
		url: `${API_URL}/api/applications/boarding/qa/assignable_users`,
	};

	return axiosWithAuth(options);
}
